import { styled } from "@mui/system"
import { Box, Typography } from "@mui/material"

export const ErrorTitle = styled(Typography)({
  color: "var(--cherry)",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  paddingLeft: "10px",
  paddingTop: "10px",
})

export const ErrorDescription = styled(Typography)({
  color: "var(--grey-grey-05)",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  paddingLeft: "15px",
})

export const CalloutBox = styled(Box)({
  padding: "16px",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
  borderRadius: "8px",
  background: "var(--danger-tertiary)",
})

export const CalloutText = styled(Typography)({
  color: "var(--danger-grey-06)",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
})
